import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace GCRNitrous50 {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "checkbox",
          label: "Nitrous 50",
          multiSelect: false,
          options: [
            {
              value: Constants.dog_class_element.nitrous_50,
              id: Constants.dog_class_element.nitrous_50,
            },
          ],
        },
      ],
    },
  ];
}
